module.exports = __webpack_public_path__ + "static/img/Sustainability 15.3f95691a.webp";